import { DeviceSizes, Link } from 'beek-design-system';
import styled from 'styled-components';

const AlphabetContainer = styled.div<AlphabetProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: ${(props): string =>
    props.type === 'bookPage' ? '0rem' : '4rem'};
  justify-content: ${(props): string =>
    props.type === 'bookPage' ? 'flex-start' : ''};
  @media ${DeviceSizes.mobileM} {
    height: 10rem;
    align-items: center;
  }

  @media ${DeviceSizes.laptop} {
    height: 2rem;
    justify-content: ${(props): string =>
      props.type === 'bookPage' ? 'space-evenly' : ''};
  }
`;

const CharContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 1.25rem;
  height: 1.25rem;
  @media ${DeviceSizes.mobileM} {
    margin-right: 0.625rem;
  }
  @media ${DeviceSizes.laptop} {
    margin-bottom: 0rem;
    margin-right: 0rem;
  }
`;

type AlphabetProps = {
  slug?: string;
  type?: string;
};

const defaultProps = {
  type: 'sitemap',
  slug: '',
};

const Alphabet = (props: AlphabetProps): JSX.Element => {
  const { slug, type } = props;

  const getAlphabet = (): JSX.Element | JSX.Element[] => {
    const alphabet: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#0123456789'.split(
      ''
    );
    const links = alphabet.map((item) => {
      const url = `/html_sitemap/audiolibros_${item.toLocaleLowerCase()}.html`;
      if (slug === '' ? item === '#' : slug?.toUpperCase() === item) {
        return (
          <CharContainer key={item}>
            <Link
              href={url}
              pointerEvent="none"
              hoverType="sitemap"
              type="sitemap"
              textDecoration="none"
              typographyType="subtitle1"
              colorVariant="beekBlue"
            >
              {item}
            </Link>
          </CharContainer>
        );
      }
      return (
        <CharContainer key={item}>
          <Link
            href={url}
            textDecoration="none"
            hoverType="sitemap"
            typographyType="subtitle1"
            colorVariant="gray100"
          >
            {item}
          </Link>
        </CharContainer>
      );
    });
    return links;
  };

  return <AlphabetContainer type={type}>{getAlphabet()}</AlphabetContainer>;
};

Alphabet.defaultProps = defaultProps;

export default Alphabet;
